import { TYPE } from '../../constants'
import { GtmPrizesClickModel } from '../../models'
import { BaseBuilder } from '../base.builder/base.builder'

export class PrizesClickBuilder extends BaseBuilder {
  constructor(data) {
    const models = new Map([[TYPE.GTM_4, GtmPrizesClickModel]])
    super(models, data)
  }
}
